import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { EmployeeListFilter } from "../models/employeeOverview.model";
import { employeeOverviewService } from "../services/employeeOverviewService";

export const employeeOverviewQueryKey = (filter: EmployeeListFilter) =>
    ["employee-overview", filter] as const;

export const useEmployeeOverviewData = (filter: EmployeeListFilter) =>
    useQuery({
        queryKey: employeeOverviewQueryKey(filter),
        queryFn: () => employeeOverviewService.getPage({ filter }),
        placeholderData: keepPreviousData,
    });
